var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGithub(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.64mm",
    height: "5.56mm",
    viewBox: "0 0 16 15.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.33,8.9A7.16,7.16,0,0,0,8,1.93a7.16,7.16,0,0,0-7.33,7,7,7,0,0,0,5.21,6.68c-.26,0-.41.06-.41.1A8.37,8.37,0,0,0,8,15.87a8.37,8.37,0,0,0,2.53-.19s-.15-.07-.41-.1A7,7,0,0,0,15.33,8.9Z",
    transform: "translate(0 -0.13)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8,.13A8,8,0,0,0,5.47,15.72c.4.07.55-.18.55-.39s0-.82,0-1.49c-2.23.49-2.7-.94-2.7-.94a2.07,2.07,0,0,0-.89-1.17c-.72-.5.06-.49.06-.49a1.68,1.68,0,0,1,1.22.83A1.7,1.7,0,0,0,6,12.73a1.68,1.68,0,0,1,.51-1.07c-1.78-.2-3.64-.89-3.64-3.95a3.1,3.1,0,0,1,.82-2.15A2.87,2.87,0,0,1,3.8,3.44s.67-.21,2.2.82A8.31,8.31,0,0,1,8,4a8.31,8.31,0,0,1,2,.27c1.53-1,2.2-.82,2.2-.82a2.87,2.87,0,0,1,.08,2.12,3.1,3.1,0,0,1,.82,2.15c0,3.07-1.87,3.75-3.65,3.94A1.92,1.92,0,0,1,10,13.14c0,1.07,0,1.93,0,2.19s.15.46.55.39A8,8,0,0,0,8,.13Z",
    transform: "translate(0 -0.13)",
    style: {
      fill: "#161514",
      fillRule: "evenodd"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithub);
export default __webpack_public_path__ + "static/media/github.50ffa7068a13eebb83454c2f53c92960.svg";
export { ForwardRef as ReactComponent };